import { Helpers } from '../../helpers';
import { IBuildSheetActivity } from '../../interfaces/ibuild-sheet-activity';
import { DrillingCost } from '../drilling-cost';

export class BuildSheetActivityBase {
  BuildSheetActivityId: number;
  Phase: string;
  Step: string | null;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  DrillingCosts_BuildSheetActivity?: Array<DrillingCost> | null;

  constructor(item?: IBuildSheetActivity) {
    if (item) {

      this.BuildSheetActivityId = item.BuildSheetActivityId;
      this.Phase = item.Phase;
      this.Step = item.Step;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.DrillingCosts_BuildSheetActivity = Helpers.createClassArray(DrillingCost, item.DrillingCosts_BuildSheetActivity);
    }
  }
}